import { useEffect, useState } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _cache = null;
let _pending = null;

// Feature-Schalter aus dem Backend (GET /api/features). Default: alles aus, bis geladen.
export const useFeatures = () => {
  const [features, setFeatures] = useState(_cache || { loaded: false, notfall: false });
  useEffect(() => {
    if (_cache) { setFeatures(_cache); return; }
    _pending = _pending || axios.get(`${API}/features`).then((r) => ({ loaded: true, notfall: false, ...r.data })).catch(() => ({ loaded: true, notfall: false }));
    _pending.then((f) => { _cache = f; setFeatures(f); });
  }, []);
  return features;
};

export const FeatureGate = ({ flag, children }) => {
  const f = useFeatures();
  if (!f.loaded) return null;
  return f[flag] ? children : <Navigate to="/" replace />;
};
